export const ROUTE_SET = 'admin-check.ROUTE_SET'
export const ERROR_SET = 'admin-check.ERROR_SET'
export const LOADING_SET = 'admin-check.LOADING_SET'
export const KEYWORD_SET = 'admin-check.KEYWORD_SET'
export const ORDERS_SET = 'admin-check.ORDERS_SET'
export const PURCHASE_SET = 'admin-check.PURCHASE_SET'
export const EVENT_SET = 'admin-check.EVENT_SET'
